var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag",style:({borderColor: _vm.color, color: _vm.color, fontSize: _vm.size+'px'})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }